export default __webpack_public_path__ + "static/media/exterior10.de8e49fd.webp";